export const CRM_TYPES = {
    OCTOPUS: "Octopus",
    OPTIMA: "Optima",
    SECRET_DEAL: "SecretDeal",
} as const;